export default __webpack_public_path__ + "static/media/Cameroon.56ba9e8d.png";